import { c as _c } from "react/compiler-runtime";
import { PatientDynamicFieldType } from "@/types/enums";
import PatientHealthFieldDialog from "./patient-health-field-dialog";
const PATIENT_REPORTED_SYMPTOMS_CONFIG = {
  type: PatientDynamicFieldType.PATIENT_REPORTED_SYMPTOMS,
  title: "Patient Reported Symptoms",
  description: "Symptoms the patient reported. Information from patient forms will appear here automatically.",
  placeholder: "e.g., Fatigue, Low libido",
  addButtonText: "Add symptom",
  addAnotherButtonText: "Add another symptom"
};
interface PatientReportedSymptomsDialogProps {
  children?: React.ReactNode;
  patientId: string;
}
export default function PatientReportedSymptomsDialog(t0) {
  const $ = _c(3);
  const {
    children,
    patientId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== patientId) {
    t1 = <PatientHealthFieldDialog config={PATIENT_REPORTED_SYMPTOMS_CONFIG} patientId={patientId}>{children}</PatientHealthFieldDialog>;
    $[0] = children;
    $[1] = patientId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}